import { render } from "./FaqContent.vue?vue&type=template&id=103858c8&scoped=true"
import script from "./FaqContent.vue?vue&type=script&lang=js"
export * from "./FaqContent.vue?vue&type=script&lang=js"

import "./FaqContent.vue?vue&type=style&index=0&id=103858c8&lang=scss&scoped=true"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103858c8"]])

export default __exports__